<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="否是通用配件">
              <a-select v-model="queryParam.commonFlag" allowClear="true">
                <a-select-option value="0">通用</a-select-option>
                <a-select-option value="1">不通用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="配件类型">
              <a-select v-model="queryParam.accessoryType" :allowClear="true" showSearch optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="type in dataType" :title="type.accessoryType" :key="type.accessoryType">{{
                    type.accessoryType
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="配件名称">
              <a-select v-model="queryParam.accessoryName" :allowClear="true" showSearch optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="type in dataName" :title="type.accessoryName" :key="type.accessoryName">{{
                    type.accessoryName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="配件型号">
              <a-select v-model="queryParam.accessoryCategory" :allowClear="true" showSearch optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="type in dataCategory" :title="type.accessoryCategory"
                  :key="type.accessoryCategory">{{ type.accessoryCategory }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="配件规格" style="margin-left: 24px">
              <a-select v-model="queryParam.accessorySpecification" :allowClear="true" showSearch
                optionFilterProp="children" :filterOption="filterOption">
                <a-select-option v-for="type in dataSpecification" :title="type.accessorySpecification"
                  :key="type.accessorySpecification">{{ type.accessorySpecification }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="产品类别">
              <a-select v-model="queryParam.installType" allowClear="true">
                <a-select-option v-for="type in restaurantTypes2" :title="type.label" v-bind:value="type.code">{{
                    type.label
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="企业名称">
              <a-select v-model="queryParam.enterpriseId" showSearch optionFilterProp="children" @change="handleChange"
                :filterOption="filterOption" allowClear="true">
                <a-select-option v-for="item in data2" :title="item.title" :value="item.key">{{
                    item.title
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="型号" style="margin-left: 28px">
              <a-select v-model="queryParam.modelId" allowClear="true" showSearch optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="item in data3" :title="item.modelName" :value="item.modelId">{{
                    item.modelName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="品牌" style="margin-left: 50px">
              <a-select v-model="queryParam.brandId" allowClear="true" showSearch optionFilterProp="children"
                :filterOption="filterOption">
                <a-select-option v-for="item in data4" :title="item.brandName" :value="item.brandId">{{
                    item.brandName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="配件状态">
              <a-select v-model="queryParam.forbiddenStatus" allowClear="true">
                <a-select-option value="0">启用</a-select-option>
                <a-select-option value="1">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <span class="table-page-search-submitButtons">
            <a-row type="flex" justify="space-between">
              <a-col :span="15"></a-col>
              <a-col :span="6" style="text-align: right">
                <a-button htmlType="submit" type="primary" style="margin-right: 8px" @click="$refs.table.refresh(true)">
                  查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">清空</a-button>
              </a-col>
            </a-row>
          </span>
        </a-row>
      </a-form>
    </div>
    <a-divider />
    <div class="table-operator">
      <a-row type="flex" justify="space-between">
        <a-col :span="16"></a-col>
        <a-col :span="4" style="text-align: right">
          <a-button value="0" v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
        </a-col>
        <a-dropdown v-if="removeEnable && selectedRowKeys.length > 0">
          <a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>
        </a-dropdown>
      </a-row>
    </div>
    <s-table size="default" ref="table" rowKey="accessoryId" :columns="columns" :data="loadData"
      :scroll="{ x: '200px' }" bordered>
      <!--      <span slot="accessorySpecification" slot-scope="text, record">-->
      <!--          <a-popover>-->
      <!--            <template slot="content">-->
      <!--              <p>企业全称:{{text}}</p>-->
      <!--              <p>负责人:{{record.enterprisePrincipal}}</p>-->
      <!--              <p>联系方式:{{record.principalPhone}}</p>-->
      <!--              <p>技术人员:{{record.technology}}</p>-->
      <!--              <p>技术电话:{{record.technologyPhone}}</p>-->
      <!--              <p>技术人员2:{{record.technology2}}</p>-->
      <!--              <p>技术2电话客服负责人:{{record.technology2Phone}}</p>-->
      <!--              <p>客服负责人:{{record.customerService}}</p>-->
      <!--              <p>客服负责人电话:{{record.customerServicePhone}}</p>-->
      <!--            </template>-->
      <!--             <span class="hover">{{text}} </span>-->
      <!--          </a-popover>-->
      <!--        </span>-->
      <span slot="accessorySpecification" slot-scope="text, record">
        <a-popover>
          <template slot="content">
            <div style="overflow-y:auto;max-height:250px;padding-right: 20px">
              <p v-for="item in record.enterpriseList">{{ item }}</p>
            </div>
          </template>
          <span class="hover">{{ text }} </span>
        </a-popover>
      </span>

      <span slot="commonFlag" slot-scope="text, record">
        <a-text v-if="record.commonFlag == 0">通用 </a-text>
        <a-text v-else="record.commonFlag == 1">不通用</a-text>
      </span>

      <span slot="action" slot-scope="text, record">
        <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>

        <a-divider type="vertical" />
        <a v-if="editEnabel" @click="detailBtn(record)">配置</a>
        <span v-if="editEnabel">
          <a-divider type="vertical" />
          <a v-if="record.forbidden == '1'" @click="delById(record)">启用</a>
          <a v-if="record.forbidden == '0'" @click="delById(record)">禁用</a>
        </span>
        <a-divider type="vertical" />
        <a v-if="removeEnable" @click="delByIds(record)">删除</a>

        <!--          <a v-if="forbiddenStatus==0" @click="delById(record.accessoryId)">启用</a>-->
      </span>
    </s-table>
    <accessory-modal ref="modal" @ok="handleOk(arguments, userDefined)" />
    <a-modal title="配置" style="top: 20px;" :width="800" v-model="dateModel" :confirmLoading="confirmLoading"
      :footer="false">
      <a-form :form="form">
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业名称" style="width:410px;">
              <a-input-search style="margin-bottom: 8px" @search="onSearch" v-model="collectSearch" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div>
        <span style="margin-left: 10%">* 企业配置 : </span>
        <a-tree checkable v-model="checkedKeys" @expand="onExpand" :expandedKeys="expandedKeys"
          :autoExpandParent="autoExpandParent" :defaultExpandedKeys="['enterprise']" :treeData="treeData"
          :defaultCheckedKeys="checkedKeys" style="margin-left: 20%" @check="onCheck">
          <template slot="title" slot-scope="{ title }">
            <span>{{ title }}</span>
          </template>
        </a-tree>
      </div>
      <a-row>
        <a-col :span="10"></a-col>
        <a-col :span="6">
          <div v-if="commonFlag2 == 1">
            <a-button @click="relevance" type="primary">关联</a-button>
            <a-button style="margin-left: 10px " @click="exclude">取消</a-button>
          </div>

          <div v-if="commonFlag2 == 0">
            <a-button @click="relevance" type="primary">排除</a-button>
            <a-button style="margin-left: 10px " @click="exclude">取消</a-button>
          </div>
        </a-col>
      </a-row>
    </a-modal>

    <a-modal title="配置型号" style="top: 20px;" :width="1000" @expand="onExpand" :expandedKeys="expandedKeys"
      :autoExpandParent="autoExpandParent" v-model="dateModel2" :confirmLoading="confirmLoading" :cancelText="slot"
      :footer="null">
      <a-form :form="form2">
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配置型号" style="width:410px;">
              <a-input-search style="margin-bottom: 8px" @search="onSearch2" v-model="collectSearch2" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <a-tree checkable @expand="onExpand2" :expandedKeys="expandedKeys2" :autoExpandParent2="autoExpandParent2"
        v-model="checkedKeys2" @change="onChange2" @select="onSelect" :selectedKeys="selectedKeys2"
        :treeData="boxLis2" />

      <a-row>
        <a-col :span="10"></a-col>
        <a-col :span="6">
          <a-button @click="relevance2" type="primary">保存</a-button>
          <a-button style="margin-left: 10px " @click="exclude">取消</a-button>
        </a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { getStorageAccessoryList } from '@/api/accessory/storageAccessory'
import {
  selAccessory,
  selectbrand,
  selectmodel,
  configAccessoryModel,
  configAccessoryEnterprise,
  getSelectTree,
  getAccessoryList,
  addAccessory,
  delAccessoryTwo,
  delAccessory1,
  selectenterprise,
  selectenterprise2,
  configSave
} from '@/api/accessory/accessory'
import {
  selectAccessorySpecification,
  selectAccessoryCategory,
  selectAccessoryName,
  selectAccessoryType
} from '@/api/accessory/supplier'

import accessoryModal from './modules/accessoryModal.vue'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import IconText from '../list/search/components/IconText'

const plainOptions = ['Apple', 'Pear', 'Orange']
const defaultCheckedList = ['Apple', 'Orange']

export default {
  name: 'TableList',
  components: {
    IconText,
    STable,
    accessoryModal
  },
  data() {
    return {
      collectSearch: '',
      collectSearch2: '',
      enterpriseId: [],
      dataList: [],
      treeList: [
        {
          title: '',
          key: '',
          children: ''
        }
      ], // 筛选后的值
      // 配件规格列表
      dataSpecification: '',
      // 配件型号列表
      dataCategory: '',
      // 配件名称列表
      dataName: '',
      // 配件类型列表
      dataType: '',

      // 品牌列表
      data4: '',
      // 型号列表
      data3: '',
      // 企业列表
      data2: '',
      value: undefined,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      accessory: {},
      form: this.$form.createForm(this),
      ids: '',
      modelAccessories: [],
      modelAccessories2: [],
      enterprise: [],
      enterprise2: [],
      dateModel: false,
      dateModel2: false,
      expandedKeys: [],
      expandedKeys2: [],
      autoExpandParent: true,
      autoExpandParent2: true,
      checkedKeys: [],
      checkedKeys2: [],
      boxLis: {},
      boxLis2: {},
      boxLis3: [],
      mdl: {},
      delFlag: 1,
      commonFlag: '',
      commonFlag2: '',
      // 高级搜索 展开/关闭
      advanced: false,
      checkedList: defaultCheckedList,
      indeterminate: true,
      checkAll: false,
      plainOptions,
      idsLis: '',
      treeData: '',
      treeData2: '',
      boxLis5: '',
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '操作',
          width: '200px',
          dataIndex: 'action',

          scopedSlots: { customRender: 'action' }
        },

        {
          title: '产品类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '配件类型',
          dataIndex: 'accessoryType',
          align: 'center'
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
          align: 'center'
        },

        {
          title: '配件型号',
          dataIndex: 'accessoryCategory',
          align: 'center'
        },
        {
          title: '配件规格',
          dataIndex: 'accessorySpecification',
          align: 'center',
          scopedSlots: { customRender: 'accessorySpecification' }
        },
        {
          title: '是否通用配件',
          dataIndex: 'commonFlag',
          align: 'center'
        },
        {
          title: '配件状态',
          dataIndex: 'forbiddenStatus',
          align: 'center'
        },
        {
          title: '修改时间',
          dataIndex: 'updateTime',
          align: 'center'
        },
        {
          title: '修改人',
          dataIndex: 'updateBy',
          align: 'center'
        },
        {
          title: '添加人',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          align: 'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log(this.queryParam)
        return getAccessoryList(Object.assign(parameter, this.queryParam))
      },

      selectedRowKeys: [],
      restaurantTypes2: [],
      selectedRows: [],
      addEnable: checkPermission('addAccessoryModel'),
      editEnabel: checkPermission('editAccessoryModel'),
      removeEnable: checkPermission('deleteAccessoryModel'),
      // configureEnable: checkPermission('stock:accessory:configure'),

      removeEnable2: checkPermission('stock:accessory:remove2')
    }
  },
  filters: {},
  async created() {
    // 配件规格
    selectAccessorySpecification().then(res => {
      console.log(res)
      this.dataSpecification = res.rows
    })

    // 配件型号
    selectAccessoryCategory().then(res => {
      console.log(res)
      this.dataCategory = res.rows
    })

    // 配件名称
    selectAccessoryName().then(res => {
      console.log(res)
      this.dataName = res.rows
    })

    // 配件类型
    selectAccessoryType().then(res => {
      console.log(res)
      this.dataType = res.rows
    })

    // 查询品牌
    selectbrand().then(res => {
      console.log(res)
      this.data4 = res.rows
    })
    // 查询型号
    selectmodel().then(res => {
      console.log(res)
      this.data3 = res.rows
    })
    // 企业
    getSelectTree().then(res => {
      console.log(res)
      this.data2 = res.data[0].children
    })

    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    //})

    //  产品类型
    this.restaurantTypes2 = []
    this.restaurantOperTypeMap2 = await getDictMap('install_type')
    this.restaurantOperTypeMap2.forEach((value, key) => {
      this.restaurantTypes2.push({ code: key, label: value })
    })

    selectenterprise({}).then(res => {
      console.log(res)
      this.boxLis5 = res.rows
    })
  },

  //获取配件Id
  onchange2(values) {
    console.log(values)
    this.accessoryId = values
    let boxLis = this.boxLis5
    for (let i = 0; i < boxLis.length; i++) {
      if (boxLis[i].accessoryId == values) {
        this.accessoryId = boxLis[i].accessoryId
        this.accessoryName = boxLis[i].accessoryName
        this.accessoryType = boxLis[i].accessoryType
        this.accessoryCategory = boxLis[i].accessoryCategory
        this.accessorySpecification = boxLis[i].accessorySpecification
      }
    }
  },
  methods: {
    // 查询企业
    onSearch(value) {
      let arr = []
      console.log(value)
      console.log(this.treeData)
      if (value != '') {
        let children = this.treeData[0].children
        // console.log(children)
        for (var i in children) {
          // console.log(children[i])
          let title = children[i].title
          if (title.indexOf(value) != -1) {
            // console.log('sk',i,children[i])
            arr.push(children[i])
          }
        }
        console.log(arr)
          ; (this.treeList[0].title = '企业'), (this.treeList[0].key = 'enterprise')
        this.treeList[0].children = arr
        // console.log(this.treeList)
        this.treeData = this.treeList
      } else {
        this.treeData = this.treeData2
      }
      // this.checkedKeys = this.enterprise2
      // this.$nextTick(()=>{
      //   selectModelEnterprise({modelId:this.modelId}).then(res=>{
      //     console.log(res)
      //     this.checkedKeys = res.data
      //   })
      // })
    },

    onSearch2(e) {
      console.log(e)
      this.searchValue = e
      var vm = this
      //添加这行代码是为了只点击搜索才触发
      vm.searchValue = vm.searchStr
      //如果搜索值为空，则不展开任何项，expandedKeys置为空
      //如果搜索值不位空，则expandedKeys的值要为搜索值的父亲及其所有祖先
      if (vm.searchValue === '') {
        vm.expandedKeys2 = []
      } else {
        //首先将展开项与展开项副本置为空
        vm.expandedKeys2 = []
        vm.backupsExpandedKeys2 = []
        //获取所有存在searchValue的节点
        let candidateKeysList = vm.getkeyList(e, vm.boxLis2, [])
        console.log(candidateKeysList)
        vm.checkedKeys = candidateKeysList
        //遍历满足条件的所有节点
        candidateKeysList.map(item => {
          //获取每个节点的母亲节点
          var key = vm.getParentKey(item, vm.boxLis2)
          //当item是最高一级，父key为undefined，将不放入到数组中
          //如果母亲已存在于数组中，也不放入到数组中
          if (key && !vm.backupsExpandedKeys2.some(item => item === key)) vm.backupsExpandedKeys2.push(key)
        })
        console.log(vm.backupsExpandedKeys2)
        let length = this.backupsExpandedKeys2.length
        for (let i = 0; i < length; i++) {
          vm.getAllParentKey(vm.backupsExpandedKeys2[i], vm.boxLis2)
        }
        vm.expandedKeys2 = vm.backupsExpandedKeys2.slice()
        console.log(vm.expandedKeys2)
      }
    },
    //获取节点中含有value的所有key集合
    getkeyList(value, tree, keyList) {
      console.log(value, tree, keyList)
      //遍历所有同一级的树
      for (let i = 0; i < tree.length; i++) {
        let node = tree[i]
        //如果该节点存在value值则push
        if (node.title.indexOf(value) > -1) {
          keyList.push(node.key)
        }
        //如果拥有孩子继续遍历
        if (node.children) {
          this.getkeyList(value, node.children, keyList)
        }
      }
      //因为是引用类型，所有每次递归操作的都是同一个数组
      return keyList
    },
    //该递归主要用于获取key的父亲节点的key值
    getParentKey(key, tree) {
      let parentKey, temp
      //遍历同级节点
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.children) {
          //如果该节点的孩子中存在该key值，则该节点就是我们要找的父亲节点
          //如果不存在，继续遍历其子节点
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key
          } else if ((temp = this.getParentKey(key, node.children))) {
            //parentKey = this.getParentKey(key,node.children)
            //改进，避免二次遍历
            parentKey = temp
          }
        }
      }
      return parentKey
    },

    getAllParentKey(key, tree) {
      var parentKey
      if (key) {
        //获得父亲节点
        parentKey = this.getParentKey(key, tree)
        if (parentKey) {
          //如果父亲节点存在，判断是否已经存在于展开列表里，不存在就进行push
          if (!this.backupsExpandedKeys2.some(item => item === parentKey)) {
            this.backupsExpandedKeys2.push(parentKey)
          }
          //继续向上查找祖先节点
          this.getAllParentKey(parentKey, tree)
        }
      }
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 取消
    exclude() {
      this.dateModel = false
      this.dateModel2 = false
    },

    // 企业关联
    relevance() {
      if (this.commonFlag == 1) {
        if (this.checkedKeys.length > 0) {
          // if(this.treeData[0].children.length<this.enterprise.length){
          //   return this.$message.error('请至少保留一个可用企业')
          // }
        } else {
          if (this.treeData[0].children.length <= this.enterprise.length) {
            return this.$message.error('请至少保留一个可用企业')
          }
        }
      }
      if (this.commonFlag == 0) {
        if (this.checkedKeys.length == 0) {
        } else {
          // TODO 不确定逻辑是啥
          // if (this.treeData[0].children.length == this.enterprise.length) {
          //   return this.$message.error('请至少保留一个不可用企业')
          // }
          if (this.treeData[0].children.length == 0) {
            return this.$message.error('请至少保留一个不可用企业')
          }
        }
      }
      const enterprise = {
        accessoryId: this.accessoryId,
        enterpriseList: this.enterprise
      }
      configAccessoryEnterprise(enterprise).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.dateModel = false
          this.dateModel2 = true
          selectenterprise2({}).then(res => {
            console.log(res)
            this.boxLis2 = res.rows
            selAccessory({ accessoryId: this.accessoryId }).then(res => {
              if (res.code === 0) {
                // this.enterprise2 = res.data.enterprise
                //  this.modelAccessories2 = res.data.modelAccessories
                let arr = []
                for (let i = 0; i < res.data.modelAccessories.length; i++) {
                  // console.log(res.data.enterprise[i].enterpriseId)
                  // this.checkedKeys = res.data.enterprise[i].enterpriseId
                  arr.push(res.data.modelAccessories[i].modelId)
                }
                console.log(arr)
                this.checkedKeys2 = arr
              }
              console.log(this.checkedKeys2)
            })
            console.log(this.boxLis2)
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 配件关联
    relevance2() {
      if (this.checkedKeys2.length == 0 || this.checkedKeys2[0] == null) {
        return this.$message.error('请选择型号')
      }
      const enterprise = {
        accessoryId: this.accessoryId,
        modelAccessoriesList: this.checkedKeys2
      }
      configAccessoryModel(enterprise).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.dateModel = false
          this.dateModel2 = false
          this.$refs.table.refresh(false)
        } else {
          this.$message.success('操作失败')
        }
      })
    },

    // onChange(checkedList) {
    //   this.indeterminate = !!checkedList.length && checkedList.length < plainOptions.length
    //   this.checkAll = checkedList.length === plainOptions.length
    // },
    // onChange(checkedValues) {
    //   console.log('enterprise = ', checkedValues)
    //   var array1 = checkedValues
    //   this.modelAccessories = array1.slice()
    //   console.log(this.modelAccessories)
    // },
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedList: e.target.checked ? plainOptions : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },

    // onChange4(value) {
    //   console.log(value)
    //   console.log(value)
    //   console.log(`Selected: ${value}`)
    //   var array1 = value
    //   this.modelAccessories = array1.slice()
    //   console.log(this.modelAccessories)
    //   this.value = value
    // },

    onExpand2(expandedKeys2) {
      console.log('onExpand', expandedKeys2)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys2 = expandedKeys2
      this.autoExpandParent2 = true
    },

    onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys
      this.autoExpandParent = true
    },

    onCheck(checkedKeys) {
      console.log('onCheck', checkedKeys)
      this.checkedKeys = checkedKeys
    },
    onSelect(selectedKeys, info) {
      console.log('onSelect', info)
      this.selectedKeys = selectedKeys
    },

    onChange2(value) {
      console.log('onChange ', value)
      this.value = value
      console.log('checked = ', checkedValues)
    },

    //配置
    detailBtn(record) {
      this.searchValue = ''
      this.collectSearch = ''
      this.collectSearch2 = ''
      this.accessoryId = record.accessoryId
      console.log(record)
      if (record.forbiddenStatus == '启用') {
        this.forbiddenStatus = 1
      } else {
        this.forbiddenStatus = 0
      }
      if (this.forbiddenStatus == 0) {
        this.$message.success('已禁用')
      } else {
        this.boxLis = ''
        this.ids = record.accessoryId
        console.log(this.ids)
        this.commonFlag = record.commonFlag
        if (this.commonFlag == '通用') {
          this.commonFlag = 0
          this.commonFlag2 = 0
        } else {
          this.commonFlag = 1
          this.commonFlag2 = 1
        }
        this.dateModel = true
        var idsLis = this.ids
        getSelectTree().then(res => {
          // console.log(res.data)
          this.treeData = res.data
          this.treeData2 = res.data
          selAccessory({ accessoryId: this.ids }).then(res => {
            if (res.code === 0) {
              // this.enterprise2 = res.data.enterprise
              this.modelAccessories2 = res.data.modelAccessories
              let arr = []
              for (let i = 0; i < res.data.enterprise.length; i++) {
                // console.log(res.data.enterprise[i].enterpriseId)
                // this.checkedKeys = res.data.enterprise[i].enterpriseId
                arr.push(res.data.enterprise[i].enterpriseId)
              }
              console.log(arr)
              this.checkedKeys = arr
            }

            console.log(this.checkedKeys)
          })
        })
      }
    },

    handleAdd() {
      this.$refs.modal.add()
    },
    handleEdit(record) {
      // var accessoryId =  record.accessoryId
      if (record.forbiddenStatus == '启用') {
        this.forbiddenStatus = 1
      } else {
        this.forbiddenStatus = 0
      }
      if (this.forbiddenStatus == 0) {
        this.$message.success('已禁用')
      } else {
        this.$refs.modal.edit(record)
      }
    },

    handleOk(userDefined) {
      console.log('userDefined', userDefined)
      if (userDefined != undefined && userDefined.length != 0) {
        console.log('userDefined[1]', userDefined[1])
        this.searchValue = ''
        this.collectSearch = ''
        this.collectSearch2 = ''
        this.dateModel = true
        this.commonFlag = userDefined[0].commonFlag
        this.commonFlag2 = userDefined[0].commonFlag
        this.accessoryId = userDefined[1]
        console.log('this.accessoryId', this.accessoryId)
        getSelectTree().then(res => {
          // console.log(res.data)
          this.treeData = res.data
          this.treeData2 = res.data
          selAccessory({ accessoryId: userDefined[1] }).then(res => {
            if (res.code === 0) {
              // this.enterprise2 = res.data.enterprise
              this.modelAccessories2 = res.data.modelAccessories
              let arr = []
              for (let i = 0; i < res.data.enterprise.length; i++) {
                // console.log(res.data.enterprise[i].enterpriseId)
                // this.checkedKeys = res.data.enterprise[i].enterpriseId
                arr.push(res.data.enterprise[i].enterpriseId)
              }
              console.log(arr)
              this.checkedKeys = arr
            }
            if (userDefined[2] != undefined) {
              this.$refs.table.refresh(true)
            } else {
              this.$refs.table.refresh(false)
            }

            console.log(this.checkedKeys)
          })
        })
      } else {
        this.$refs.table.refresh(false)
        console.log('handleSaveOk')
      }
    },

    handleSubmit2() {
      this.dateModel = false
      this.dateModel2 = true
      selectenterprise2({}).then(res => {
        console.log(res)
        this.boxLis2 = res.rows
        console.log(this.boxLis2)
      })
    },

    handleSubmit3(idsLis) {
      this.dateModel = false
      this.dateModel2 = true
      console.log(this.modelAccessories)
      console.log(this.enterprise)
      var modelAccessories = this.modelAccessories
      var enterprise = this.enterprise
      var idsLis = this.ids
      // this.enterprise = {
      //   enterprise:modelAccessories
      // }
      // this.modelAccessories ={
      //   modelAccessories:enterprise
      // }
      // this.accessory = {
      //   accessoryId:idsLis,
      //   enterprise:this.enterprise,
      //   modelAccessories:this.modelAccessories
      // }
      configSave({ accessoryId: this.ids, modelAccessories: this.enterprise, enterprise: this.modelAccessories }).then(
        res => {
          console.log(res)
          this.boxLis2 = res.rows
          // for(var i=0;i<res.rows.length;i++){
          //     var boxLis2 = res.rows[i].brand
          //   for(var j=0;j<boxLis2.length;j++){
          //     this.boxLis3 = boxLis2[j]
          //   }
          // }
          console.log(this.boxLis2)
          console.log(this.boxLis3)
          this.array1 = []
        }
      )
    },

    // 删除
    delByIds(record) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          delAccessory1({ accessoryId: record.accessoryId, delFlag: 1 }).then(res => {
            console.log(res)
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
            that.selectedRowKeys = []
          })
        },
        onCancel() {
          console.log('Cancel')
        }
      })
    },

    // 启用、禁用
    delById(record) {
      var accessoryId = record.accessoryId
      var forbiddenStatus = record.forbiddenStatus
      if (forbiddenStatus == '启用') {
        forbiddenStatus = 1
      } else {
        forbiddenStatus = 0
      }
      delAccessoryTwo({ accessoryId: accessoryId, forbiddenStatus: forbiddenStatus }).then(res => {
        console.log(res)
        if (res.code === 0) {
          if (record.forbiddenStatus == '启用') {
            record.forbidden = '1'
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.success('启用成功')
            record.forbidden = '0'
            this.handleOk()
          }

          // this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
        this.selectedRowKeys = []
      })
    },

    SetOptionTitle() {
      var selects = document.getElementsByTagName('select')
      if (selects.length > 0) {
        for (var i = 0; i < selects.length; i++) {
          var options = selects[i].options
          if (selects[i].options.length > 0) {
            for (var j = 0; j < options.length; j++) {
              if (options[j].title == '') options[j].title = options[j].text
            }
          }
        }
      }
    }
  },

  watch: {
    checkedKeys(val) {
      for (let i = 0; i < val.length; i++) {
        if (val[i] == 'enterprise') {
          val.splice(i, 1)

          break
        }

      }
      console.log('modelAccessories', val)
      this.enterprise = val
      this.checkedKeys = val
      this.checkedKeys2 = val
      console.log(this.enterprise)
      //this.delByIds = val;
    }
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  }
}
</script>
<style>
.twobtn {
  background-color: #169bd5;
  color: white;
  width: 110px;
  font-size: 15px;
}
</style>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px;
}
</style>
